<template>
  <!-- eslint-disable -->
  <div class="page-full py-4">
    <div class="container">
      <!-- step 1 -->
      <div v-if="step === 1" class="row">
        <div class="col-lg-4 order-1" ref="purchase">
          <CardShadow>
            <div class="card-body bg-light">
              <h5>
                <b>{{ versus.name }}</b>
              </h5>
              <h6 class="text-uppercase">
                {{ dateFirst }}
              </h6>
            </div>
            <div class="card-body">
              <div>
                <span class="float-right">
                  Precio
                </span>
                <h5>
                  <b>Entradas</b>
                </h5>
              </div>
              <ul class="list-group list-group-flush">
                <li
                  v-for="(item, idx) in generalTypes"
                  :key="idx"
                  class="list-group-item px-0"
                >
                  <span>{{ item.name }}</span>
                  <b class="float-right">
                    S/ {{ item.price }}
                  </b>
                </li>
              </ul>
              <!-- <div class="mt-3">
                <b>Precio:</b>
                <small>
                  Válido para los dos partidos.
                </small>
              </div> -->
              <div class="mt-4">
                <button
                  @click="selectTickets()"
                  :disabled="loading"
                  class="btn btn-action btn-lg btn-block py-3 px-4"
                >
                  <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                  <b v-else>IR A COMPRAR</b>
                </button>
              </div>
              <div class="mt-3">
                <b>*</b>
                <small>
                  Apto para menores de 18 años acompañados de un adulto.
                </small>
              </div>
            </div>
          </CardShadow>
          <div class="d-none d-lg-block">
            <DetailSidebarExtra></DetailSidebarExtra>
          </div>
        </div>
        <div class="col-lg-8">
          <CardShadow>
            <div class="card-body">
              <h3 class="card-title mb-0">
                {{ eventName }}
              </h3>
            </div>
            <img
              :src="eventImg"
              alt="evento"
              class="img-fluid"
            >
            <div class="card-body">
              <p class="lead">
                {{ eventData.description }}
              </p>
              <h3>
                Información adicional
              </h3>
              <div v-html="eventData.information"></div>
            </div>
          </CardShadow>

          <!-- faqs -->
          <CardShadow v-for="(faq, idx) in faqs" :key="idx">
            <div class="card-body border-bottom">
              <div v-b-toggle="`collapse-faq-${idx}`" class="d-block el-pointer">
                <span class="float-right">
                  Ver
                </span>
                <h4 class="card-title mb-0">
                  {{ faq.title }}
                </h4>
              </div>
            </div>
            <b-collapse :id="`collapse-faq-${idx}`" accordion="accordion-info">
              <div class="card-body bg-light">
                <p v-html="faq.description"></p>
              </div>
            </b-collapse>
          </CardShadow>

          <div class="d-block d-lg-none">
            <DetailSidebarExtra></DetailSidebarExtra>
          </div>
        </div>
        <button
          @click="goToPurchase()"
          :disabled="loading"
          class="btn btn-action btn-sm btn-block py-3 btn-fidex  d-md-none rounded-0"
          :class="{'btn-fidex--hide': scrolled}"
        >
          <b>VER PRECIOS</b>
        </button>
      </div>
      <!-- step 2 -->
      <div v-if="step === 2">
        <div class="row">
          <div class="col-lg-8 mb-4" style="height: 100%">
            <div class="card border-0 shadow-sm">
              <div class="card-body border-bottom">
                <div class="row align-items-center">
                  <div class="col-12 col-md-auto pb-2">
                    <button
                      @click="goStep(1)"
                      class="btn btn-outline-primary btn-sm"
                      type="button"
                    >
                      <i class="fa fa-arrow-left"></i>
                      <span class="ml-2">Ir al Evento</span>
                    </button>
                  </div>
                  <div class="col">
                    <h4 class="card-title mb-0">
                      {{ eventName }}
                    </h4>
                  </div>
                </div>
              </div>
              <div class="card-header border-bottom-0 py-2">
                <div class="row justify-content-between align-items-center">
                  <div class="col-12 col-sm-auto text-right order-1 order-md-1">
                    <button
                      v-if="selectBlock"
                      @click="goSvgBlocks()"
                      type="button"
                      class="btn btn-secondary btn-block"
                    >
                      <b>ESCOGER OTRA ZONA</b>
                    </button>
                  </div>
                  <div class="col pt-2 pt-sm-0 text-center text-sm-left">
                    <b class="d-inline-block" style="line-height: 1">
                      Selecciona la zona de tu preferencia.
                    </b><br>
                    <small>Zona gris no disponible.</small>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="!selectBlock">
                  <SvgBlocks
                    ref="SvgBlocks"
                    :svgHtml="eventData.venueSvgStructure"
                    :types="typesByGroup"
                    @select="onSelectZone($event)"
                  ></SvgBlocks>
                </div>
                <div v-else style="position: relative; height: 64vh;">
                  <!-- seats -->
                  <SvgSeats
                    ref="svgSeats"
                    v-model="seatsSelect"
                    :svg-html="blockSvg.path"
                    @on-verify-seat="onSelectSeat"
                    @update-seat="updateSeat"
                  ></SvgSeats>
                  <div v-if="loading" class="loader-svg">
                    <Loader></Loader>
                  </div>
                  <!-- panorama view -->
                  <div
                    v-if="panoramaView"
                    style="position: absolute; top: 3px; left: 3px; right: 3px; bottom: 3px"
                  >
                    <Panorama :src="blockSvg.preview" />
                  </div>
                  <div v-if="blockSvg.preview" style="position: absolute; top: 10px; right: 10px">
                    <button
                      @click="panoramaView = !panoramaView"
                      type="button"
                      class="btn btn-dark"
                    >
                      <i v-if="!panoramaView" class="fa fa-eye"></i>
                      <i v-else class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-4">
            <div class="card border-0 shadow-sm" style="height: 100%">
              <div v-if="!selectBlock" class="p-3">
                <span class="float-right my-1">
                  Precio
                </span>
                <h5 class="card-title my-1">
                  Entradas
                </h5>
              </div>
              <div v-else class="p-3">
                <span class="float-right my-1">
                  Disponible
                </span>
                <h5 class="card-title my-1">
                  Sector
                </h5>
              </div>
              <!-- types -->
              <ul v-if="!selectBlock" class="list-group list-group-flush">
                <li
                  v-for="(item, idx) in generalTypes"
                  :key="idx"
                  class="list-group-item"
                  :class="{active: isActive(item.blockId)}"
                >
                <span>{{ item.name }}</span>
                  <b class="float-right">
                    S/ {{ item.price }}
                  </b>
                </li>
              </ul>
              <ul v-else class="list-group list-group-flush">
                <li
                  class="list-group-item"
                  :style="{borderLeft: `3px solid ${blockSvg.color}`}"
                >
                  <span>
                    {{ blockId.groupName || blockId.name }}
                  </span>
                  <b class="float-right">
                    S/ {{ blockId.price }}
                  </b>
                </li>
                <li
                  class="list-group-item small"
                >
                  Stock
                  <b class="float-right">
                    {{ zone.stock || 'Agotado' }}
                  </b>
                </li>
              </ul>
              <div class="card-body">
                <div v-if="zone.name" class="text-center mb-3">
                  <div>
                    <b>{{ zone.name }}</b>
                    <b> - </b>
                    <b> S/ </b>
                    <b>{{ zone.price }}</b>
                  </div>
                  <div class="d-inline-block px-3 py-1 rounded" style="background: #ccc">
                    <b>{{ versus.smallName }}</b>
                  </div>
                  <div class="my-3">
                    <div
                      v-for="i in seatsMeta"
                      class="d-flex justify-content-between border-bottom"
                    >
                      <span class="px-1">
                        Sector: <b>{{ i.sector }}</b>
                      </span>
                      <span class="px-1">
                        Fila: <b>{{ i.row }}</b>
                      </span>
                      <span class="px-1">
                        Asiento: <b>{{ i.seat }}</b>
                      </span>
                    </div>
                  </div>
                  <h4 class="my-4">
                    Total a pagar: <b>S/ {{ total }}</b>
                  </h4>
                </div>
                <div v-if="zone.name">
                  <button
                    v-if="blockSvg.path"
                    @click="goRegister()"
                    :disabled="!quantityTotal"
                    class="btn btn-action btn-lg btn-block"
                  >
                    <span>
                      Continuar
                    </span>
                  </button>
                  <button
                    v-else
                    @click="goQuantity()"
                    class="btn btn-action btn-lg btn-block"
                  >
                    <span>
                      Ir a seleccionar cantidad
                    </span>
                  </button>
                </div>
                <p v-else class="text-center">
                  <b>Selecciona tu zona en el mapa.</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <CardShadow>
          <div class="py-1 px-2">
            Publicidad
          </div>
          <img src="https://picsum.photos/1920/250" alt="banner" class="img-fluid">
        </CardShadow> -->
      </div>
      <!-- modal quantity -->
      <b-modal
        v-model="modals.quantity"
        no-close-on-backdrop
        hide-header
        hide-footer
        class="p-0"
      >
        <a href="#" @click.prevent="modals.quantity = false" class="btn-close-modal-intern">
          <i class="fa fa-times text-dark"></i>
        </a>
        <div class="py-4">
          <div v-show="modalQuantity" class="text-center">
            <h4>
              Entradas para: <b>{{ zone.name }}</b>
            </h4>
            <hr>
            <div>
              <h5 class="text-upper mb-2">
                Selecciona la <b>cantidad</b> de entradas
              </h5>
              <h4 class="text-upper mb-4">
                Disponible: <b>{{ zone.stock > 0 ? zone.stock : 'Agotado' }}</b>
              </h4>
              <div class="mb-5">
                <QuantityForm v-model="quantity" :stock="zone.stock > 0 ? zone.stock : 0" :code="zone.blockId"></QuantityForm>
              </div>
              <h4 class="mb-5">
                Total a pagar: <b>S/ {{ total }}</b>
              </h4>
              <div>
                <button
                  @click="modalQuantity = false"
                  class="btn btn-action btn-lg px-5"
                  :disabled="!quantity || (zone.stock < 0)"
                  type="button"
                >
                  Continuar
                </button>
              </div>
            </div>
          </div>
          <div v-show="!modalQuantity">
            <h4 class="text-center">
              Datos del comprador
            </h4>
            <hr>
            <h5 class="mb-4 text-center">
              Total a pagar: <b>S/ {{ total }}</b>
            </h5>
            <FormBuyer
              @submit="reservateTickets($event)"
              :smsSend="smsSend"
              :error="errorUser || errorReservate"
              :loading="paymentSend"
            >
              <button
                v-if="!blockSvg.path"
                @click="modalQuantity = true"
                class="btn btn-outline-secondary btn-lg mx-2 mt-2"
                type="button"
              >
                Modificar cantidad
              </button>
            </FormBuyer>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import api from '../api';

import generalTypes from '../generalTypes';

export default {
  name: 'home',
  data() {
    return {
      eventData: {},
      generalTypes,
      groupTypes: [],
      typesByGroup: [],
      seatsSelect: {},
      loading: false,
      paymentSend: false,
      step: 1,
      modalQuantity: true,
      blockId: {},
      blockSvg: {},
      zone: {},
      quantity: 1,
      selectBlock: false,
      modals: {
        quantity: false,
        svg: false,
      },
      errorUser: null,
      errorReservate: null,
      scrolled: false,
      panoramaView: false,
    };
  },
  created() {
    if (!this.$root.binBbva) {
      this.$router.push({ name: 'Welcome' });
    } else {
      this.getEvent();
    }
  },
  computed: {
    total() {
      if (!this.zone.name) return 0;
      return (parseFloat(this.zone.price) * this.quantityTotal).toFixed(2);
    },
    typesIds() {
      return this.typesByGroup.map(el => el.id).join(',');
    },
    quantityTotal() {
      if (this.blockSvg.path) {
        return Object.values(this.seatsSelect).length;
      }
      return this.quantity;
    },
    svgStructure() {
      return JSON.parse(this.eventData.venueBlockStructure);
    },
    seatsMeta() {
      return Object.keys(this.seatsSelect).map((el) => {
        const arr = el.split('-');
        return {
          sector: arr[arr.length - 4],
          row: arr[arr.length - 2],
          seat: arr[arr.length - 1],
        };
      });
    },
    faqs() {
      if (!this.eventData.metadata) return [];
      return JSON.parse(this.getFieldMeta(this.eventData.metadata, 'faq_buy'));
    },
    smsSend() {
      if (!this.eventData.metadata) return true;
      return parseInt(this.getFieldMeta(this.eventData.metadata, 'active_sms'), 0);
    },
  },
  methods: {
    goStep(step) {
      this.step = step;
    },
    isActive(key) {
      return this.blockSvg.id === key && this.zone.id;
    },
    isZoneActive(key) {
      return this.zone.id === key;
    },
    goSvgBlocks() {
      this.selectBlock = false;
      this.zone = {};
      this.seatsSelect = {};
      setTimeout(() => {
        this.$refs.SvgBlocks.disableBlocks();
      }, 400);
    },
    async getEvent() {
      const res = await api.getDataEvent(this.eventId);
      if (res) {
        this.eventData = res;
      }
    },
    async selectTickets() {
      // this.loading = true;
      // const url = `${api.nodeUrl}/ticket-type-group`;
      // const { data: res } = await api.axios.get(url, {
      //   params: {
      //     activityId: this.eventId,
      //     dateHourId: this.hourId,
      //     key: this.projectKey,
      //   },
      // });
      // this.groupTypes = res.data;

      // load types
      this.loadTypes();
      // this.loading = false;
      // this.goStep(2);
      // window.scroll(0, 0);
    },
    async loadTypes() {
      this.loading = true;
      const url = `${api.nodeUrl}/ticket-types`;
      // const group = groupTypes.find(el => el.blockId === this.projectKey);
      const { data: res } = await api.axios.get(url, {
        params: {
          // groupId: group.groupId,
          activityId: this.eventId,
          dateHourId: this.hourId,
          key: this.projectKey,
        },
      });
      this.loading = false;
      this.goStep(2);
      window.scroll(0, 0);
      if (!res.status) return;
      this.typesByGroup = res.data;
      setTimeout(() => {
        this.$refs.SvgBlocks.disableBlocks();
      }, 700);
    },
    onSelectZone({ id }) {
      this.zone = {};
      const blockSvg = this.svgStructure.find(el => el.id === id);
      const blockId = this.typesByGroup.find(el => el.blockId === id);
      if (!blockSvg) return;
      this.blockSvg = blockSvg;
      if (!blockId) return;
      this.blockId = blockId;
      this.zone = blockId;
      if (blockSvg.path) {
        this.selectBlock = true;
        this.loadZone();
      } else {
        this.selectZone(blockId);
      }
    },
    selectZone(zone) {
      this.zone = zone;
      this.zone.id = this.zone.ticketTypeId ? this.zone.ticketTypeId : this.zone.id;
      if (this.quantity > this.zone.stock && this.zone.stock > 0) {
        this.quantity = this.zone.stock;
      }
      if (this.zone.blockId === 'NORTE' || this.zone.blockId === 'SUR') {
        if (this.quantity > 4) {
          this.quantity = 4;
        }
      }
      this.goQuantity();
    },
    // logic seats
    loadZone() {
      this.loading = true;
      const payload = {
        typesAvailable: this.typesIds,
        venueId: this.eventData.idVenue,
        activityId: this.eventData.activity_id,
        dateHourId: this.hourId,
        blockId: this.blockSvg.id,
      };
      const payloadBuyed = {
        activityId: this.eventData.activity_id,
        dateHourId: this.hourId,
      };
      setTimeout(() => {
        this.$refs.svgSeats.init(async () => {
          // free seats
          const seatsFree = await api.getSeatsStringByBlockId(payload);
          const arrAll = seatsFree.map(item => item.seats);
          if (!arrAll.length) {
            this.loading = false;
            this.goSvgBlocks();
            return;
          }
          const arr = arrAll.join().split(',');
          const arrSeats = arr.map(item => ({ id: item }));
          this.$refs.svgSeats.enableSeats(arrSeats);

          // buyed seats
          const seatsBuyed = await api.getSeatsBuyed(payloadBuyed);
          const arrSeatsBuyed = seatsBuyed.map(i => i.position || 'undefined');
          this.$refs.svgSeats.disableSeats(arrSeatsBuyed);

          // end init svg
          this.loading = false;
        });
      }, 500);
    },
    async onSelectSeat(data) {
      const payload = {
        activityId: this.eventData.activity_id,
        dateHourId: this.hourId,
        typesAvailable: this.typesIds,
        seat: data.id,
      };
      this.loading = true;
      const res = await api.seatVerifyAndReserved(payload);
      this.loading = false;
      if (res.available) {
        if (res.types.length > 1) {
          // this.seatMultiple = res.types;
        } else {
          // eslint-disable-next-line
          data.type = res.types[0].id;
          this.setSeatVerify(true, data);
        }
      } else {
        this.setSeatVerify(false, data);
      }
    },
    setSeatVerify(available, data) {
      this.$refs.svgSeats.setSeatVerify(available, data);
    },
    updateSeat({ type, id }) {
      const arrSeats = Object.values(this.seatsSelect);
      const arrVal = arrSeats.filter(item => item.type === type).map(i => i.id);

      if (arrVal.length > 4) {
        this.$refs.svgSeats.updateSeat(id);
        // eslint-disable-next-line
        this.$bvToast.toast('No puedes seleccionar más entradas para esta compra.', {
          title: 'Límite de compra',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000,
        });
      }
    },
    goRegister() {
      this.modals.quantity = true;
      this.modalQuantity = false;
    },
    // en seats
    goQuantity() {
      if (!this.zone.name) return;
      this.modalQuantity = true;
      this.modals.quantity = true;
    },
    redirectCheckout(transactionId) {
      this.$router.push({
        name: 'Reservate',
        params: { id: transactionId },
      });
    },
    async reservateTickets(user) {
      let validate = true;
      this.errorReservate = '';
      this.errorUser = '';
      if (user.documentType === 'DNI') {
        validate = await this.validateUser(user);
      }
      if (!validate) return;
      this.paymentSend = true;
      const url = `${api.nodeUrl}/reservation/generate`;
      const payload = {
        user,
        source: this.projectKey,
        ticket: {
          eventId: parseInt(this.eventId, 0),
          dateHourId: parseInt(this.hourId, 0),
          quantity: this.quantityTotal,
          typeId: parseInt(this.zone.id, 0),
          seats: Object.keys(this.seatsSelect),
        },
      };
      const { data: res } = await api.axios.post(url, payload);
      this.paymentSend = false;
      if (!res.status) {
        this.errorReservate = res.message;
        setTimeout(() => {
          this.errorReservate = '';
        }, 9000);
        return;
      }
      this.redirectCheckout(res.data);
    },
    async validateUser(user) {
      this.paymentSend = true;
      try {
        const url = `${api.nodeUrl}/validate-documents`;
        const { data: res } = await api.axios.post(url, [user]);
        this.paymentSend = false;
        if (!res.data[0].status) {
          this.errorUser = res.data[0].message;
          return false;
        }
        return true;
      } catch (err) {
        this.errorUser = 'Error, inténtalo en un momento.';
        this.paymentSend = false;
        setTimeout(() => {
          this.errorUser = '';
        }, 9000);
        return false;
      }
    },
    handleScroll() {
      const element = this.$refs.purchase;
      if (!element) return;
      const top = (element.offsetTop - window.innerHeight) + 150;
      this.scrolled = window.scrollY > top;
    },
    goToPurchase() {
      const element = this.$refs.purchase;
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="scss">
.list-group li{
  cursor: pointer;
  &.active{
    border-color: currentcolor;
  }
}
</style>
